import SellerInfo from "./SellerInfo";

export default function MainLayout({children, ...pageProps}) {
  return(
    <SellerInfo>
      <div className="min-h-screen mx-auto w-full">
        {children}
      </div>
    </SellerInfo>
  )
}